import { ChevronDown } from 'lucide-react';
import React from 'react';
interface MenuTriggerProps {
	isOpen: boolean;
	onClick: () => void;
	icon: React.ReactNode;
	label?: string;
	disabled?: boolean;
	chevron?: boolean;
}

export const MenuTrigger: React.FC<MenuTriggerProps> = ({
	isOpen,
	onClick,
	icon,
	label,
	disabled = false,
	chevron = true
}) => {
	return (
		<button
			type='button'
			onClick={onClick}
			className='flex items-center gap-2 rounded-md p-2 text-gray-700 hover:bg-gray-100 focus:outline-none'
			disabled={disabled}
		>
			{icon}
			{label && <span className='text-sm'>{label}</span>}
			{chevron && (
				<ChevronDown
					size={15}
					strokeWidth={2}
					className={`transform transition-transform duration-200 ${
						isOpen ? 'rotate-180' : ''
					}`}
				/>
			)}
		</button>
	);
};
